// src/pages/Templates.jsx
import * as React from "react";
import { Tabs, Tab, Typography, Box, Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { ResumeContext } from "../ResumeContext";

// Templates
import Landing from "../components/templates/Landing";
import Temp1 from "../components/templates/Temp1";
import Temp2 from "../components/templates/Temp2";
import Temp3 from "../components/templates/Temp3";
import Temp4 from "../components/templates/Temp4";
import Temp5 from "../components/templates/Temp5";

import BasicInfoSkeleton from "../components/resume/skeletonLoader";
import GradientButton from "../components/Button";

/* ---------- TabPanel ---------- */
function TabPanel({ value, index, children }) {
  if (value !== index) return null;
  return <Box sx={{ mt: 2 }}>{children}</Box>;
}

/* ---------- MAIN COMPONENT ---------- */
export default function Templates() {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();

  //  THIS is what you were missing
  const { data, loading } = React.useContext(ResumeContext);
  console.log("Resume Data in Templates:", data);

  if (loading || !data) {
    return <BasicInfoSkeleton />;
  }

  //  Template configuration
  const templateTabs = [
    // { label: "Digital Resume", component: <Landing data={data} /> },
    { label: "Resume 1", component: <Temp1 data={data} /> },
    { label: "Resume 2", component: <Temp2 data={data} /> },
    { label: "Resume 3", component: <Temp3 data={data} /> },
    { label: "Resume 4", component: <Temp4 data={data} /> },
    { label: "Resume 5", component: <Temp5 data={data} /> },
  ];

  return (
    <Grid container sx={{ p: 3 }}>
      {/* HEADER */}
      <Grid
        size={{ xs: 12 }}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box display="flex" alignItems="center">
          <img src="/csepathshala.png" alt="logo" style={{ width: 35 }} />
          <Typography variant="h6" sx={{ ml: 1 }}>
            My Resume<span style={{ color: "#375DBE" }}></span>
          </Typography>
        </Box>

        <GradientButton
          variant="contained"
          onClick={() => navigate("/buildresume")}
        >
          Edit Resume
        </GradientButton>
      </Grid>

      {/* TABS */}
      <Grid size={{ xs: 12 }}>
        <Box display="flex" justifyContent="center" mt={3}>
          <Tabs
            value={value}
            onChange={(_, newValue) => setValue(newValue)}
            variant="scrollable"
          >
            {templateTabs.map((t, i) => (
              <Tab key={i} label={t.label} />
            ))}
          </Tabs>
        </Box>

        {/* TAB CONTENT */}
        {templateTabs.map((t, i) => (
          <TabPanel key={i} value={value} index={i}>
            {t.component}
          </TabPanel>
        ))}
      </Grid>
    </Grid>
  );
}
